/* src/modules/discounts/cards/AddDiscountCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty, keyBy, map } from 'lodash';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Button,
  Collapse,
  FormControl,
  InputLabel,
  ListItemIcon, ListItemText,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Add } from '@material-ui/icons';

import CreateOwner from '../../components/CreateOwner';

import styles from './styles';

import { getSeasons, getOwners, getOrganization } from '../../selectors';
import { createSeason as addSeason, createDiscountHolder, createDiscount } from '../../actions';
import { loadTexts } from '../../../../config/texts';
const TEXT_KEY = 'discount';

class AddDiscountCard extends React.Component {
  state = {
    season: '',
    owner: '',
    type: 'LESSON',
    body: '',
    amount: '',
    createSeason: false,
    createOwner: false,
    startDate: moment().format('Y-MM-DD'),
    endDate: moment().add(1, 'month').format('Y-MM-DD'),
    texts: loadTexts(TEXT_KEY, this.props.locale),
  }

  _onClickCreate = async () => {
    const {
      createSeason,
      createOwner,
      season,
      startDate,
      endDate,
      owner,
      type,
      body,
      amount,
    } = this.state;

    const { ownerName, ownerEmail, ownerPhone, chosenUniversities } = this._createOwner.getInfo();

    const { selectedOrganization } = this.props;
    let seasonID = season;
    let ownerID = owner;

    if (createSeason) {
      await this.props.addSeason({ seasonInput: {
        _organization: selectedOrganization._id,
        startDate: { timestamp: moment(startDate).valueOf().toString() },
        endDate: { timestamp: moment(endDate).valueOf().toString() },
      } });
      seasonID = this.props.lastAddedSeason;
    }

    if (createOwner) {
      await this.props.createDiscountHolder({ discountHolderInput: {
        name: ownerName,
        email: ownerEmail,
        phone: ownerPhone,
        _organization: selectedOrganization._id,
        universities: chosenUniversities,
      } });
      ownerID = this.props.lastAddedOwner;
    }

    const params = { type, _holder: ownerID, _season: seasonID, body };
    if (type === 'LESSON') params.percent_off = amount;
    else params.amount = amount;

    await this.props.createDiscount({ discountInput: params });
    await this.props.fetchOwners({});
    this.props.onClose();
    this.setState({
      season: '',
      owner: '',
      type: 'LESSON',
      body: '',
      amount: '',
      createSeason: false,
      createOwner: false,
      startDate: moment().format('Y-MM-DD'),
      endDate: moment().add(1, 'month').format('Y-MM-DD'),
    });
  }

  _onChangeType = ({ target: { value } }) => {
    this.setState({ type: value });
  }

  _onChangeSeason = ({ target: { value } }) => {
    this.setState({ season: value, createSeason: value === 'create_season' });
  }

  _onChangeOwner = ({ target: { value } }) => {
    const isCreate = value === 'create_owner';
    this._createOwner.toggleExpand(isCreate);
    this.setState({ owner: value, createOwner: isCreate });
  }

  _onChangeStartDate = event => {
    this.setState({ startDate: event.target.value });
  }

  _onChangeEndDate = event => {
    this.setState({ endDate: event.target.value });
  }

  _onChangeBody = event => {
    this.setState({ body: event.target.value });
  }

  _onChangeAmount = event => {
    this.setState({ amount: event.target.value });
  }

  _isValid = () => {
    const {
      createSeason,
      createOwner,
      season,
      startDate,
      endDate,
      owner,
      type,
      body,
      amount,
    } = this.state;
    let ownerName = ''; let chosenUniversities = [];
    if (this._createOwner) ({ ownerName, chosenUniversities } = this._createOwner.getInfo());
    const seasonSelected = createSeason ? !(isEmpty(startDate) || isEmpty(endDate))
      : !isEmpty(season);
    const ownerSelected = createOwner ? !(isEmpty(ownerName) || isEmpty(chosenUniversities))
      : !isEmpty(owner);
    return seasonSelected && ownerSelected && !(isEmpty(type) || isEmpty(body) || isEmpty(amount));
  };

  renderHeader = () => (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="title" color="inherit">
          {this.state.chooseUniversity ? this.state.texts.header.choose_institution : this.state.texts.header.create_new}
        </Typography>
      </Toolbar>
    </AppBar>
  )

  renderSpace = () => (
    <div className={this.props.classes.space} />
  );

  renderSelectType = (classes, type) => (
    <FormControl className={classes.typeFormControl}>
      <InputLabel htmlFor="discount_type">
        {this.state.texts.fields.discount_type}
      </InputLabel>
      <Select
        value={type}
        onChange={this._onChangeType}
        inputProps={{ name: 'discount_type', id: 'discount_type' }}
      >
        <MenuItem value="LESSON">
          {'Lesson'}
        </MenuItem>
        <MenuItem value="CREDIT">
          {'Credit'}
        </MenuItem>
      </Select>
    </FormControl>
  )

  renderSelect = (classes, type, data, selected, display, onChange) => (
    <FormControl fullWidth>
      <InputLabel htmlFor={type}>
        {`Choose ${type === 'owner' ? 'an' : 'a'} ${type}`}
      </InputLabel>
      <Select
        value={selected}
        onChange={onChange}
        inputProps={{ name: type, id: type }}
        MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {map(data, d => (
          <MenuItem key={d._id} value={d._id}>
            {display(d)}
          </MenuItem>
        ))}
        <MenuItem value={`create_${type}`}>
          {selected === `create_${type}` ? (
            `Create a new ${type}`
          ) : (
            <React.Fragment>
              <ListItemIcon>
                <Add />
              </ListItemIcon>
              <ListItemText inset primary={`Create a new ${type}`} />
            </React.Fragment>
          )}
        </MenuItem>
      </Select>
    </FormControl>
  );

  renderSeasonInput = (classes, expanded, start, end) => (
    <Collapse in={expanded} timeout="auto" unmountOnExit className={classes.collapse}>
      <Typography gutterBottom>
        {`${this.state.texts.header.organization}: ${this.props.selectedOrganization.name}`}
      </Typography>
      <TextField
        className={classes.textField}
        id="season_start_date"
        label={this.state.texts.fields.start_date}
        type="date"
        InputLabelProps={{ shrink: true }}
        value={start}
        onChange={this._onChangeStartDate}
      />
      <TextField
        className={classes.textField}
        id="season_end_date"
        label={this.state.texts.fields.end_date}
        type="date"
        InputLabelProps={{ shrink: true }}
        value={end}
        onChange={this._onChangeEndDate}
      />
    </Collapse>
  )

  renderOwnerInput = (classes, expanded) => {
    const { selectedOrganization, universities } = this.props;
    return (
      <CreateOwner
        innerRef={node => this._createOwner = node}
        organization={selectedOrganization.name}
        universities={universities}
        expanded={expanded}
      />
    );
  }

  renderBody = classes => (
    <TextField
      className={classes.textField}
      id="discount_body"
      label="Code"
      InputLabelProps={{ shrink: true }}
      value={this.state.body}
      onChange={this._onChangeBody}
    />
  )

  renderAmount = (classes, type) => (
    <TextField
      className={classes.amountField}
      id="discount_amount"
      label={type === 'LESSON' ? 'Percent Off (ex. 20 => 20% off)' : 'Amount (ex. 1000 => 10.00 credit)'}
      InputLabelProps={{ shrink: true }}
      type="number"
      value={this.state.amount}
      onChange={this._onChangeAmount}
    />
  )

  renderButton = classes => (
    <div className={classes.buttonContainerDone}>
      <Button
        color="primary"
        variant="raised"
        disabled={!this._isValid()}
        onClick={this._onClickCreate}
      >
        <Add className={classes.buttonIcon} />
        {this.state.texts.fields.create_discount}
      </Button>
    </div>
  );

  render() {
    const { classes, open, onClose, seasons, owners } = this.props;
    const { season, owner, createSeason, createOwner, type, startDate, endDate } = this.state;
    return (
      <Modal
        aria-labelledby="Add Discount"
        aria-describedby="Input a new discount code"
        open={open}
        onClose={onClose}
      >
        <Paper className={classes.paper}>
          {this.renderHeader()}
          <div className={classes.content}>
            {this.renderSelect(
              classes,
              'season',
              seasons,
              season,
              s => `${s.startDate.format('MMM DD, Y')} - ${s.endDate.format('MMM DD, Y')}`,
              this._onChangeSeason
            )}
            {!createSeason && this.renderSpace()}
            {this.renderSeasonInput(classes, createSeason, startDate, endDate)}
            {this.renderSelect(
              classes,
              'owner',
              owners,
              owner,
              o => o.name,
              this._onChangeOwner
            )}
            {!createOwner && this.renderSpace()}
            {this.renderOwnerInput(classes, createOwner)}
            {this.renderSelectType(classes, type)}
            {this.renderBody(classes)}
            {this.renderAmount(classes, type)}
            {this.renderButton(classes)}
          </div>
        </Paper>
      </Modal>
    );
  }
}

AddDiscountCard.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  seasons: PropTypes.array,
  owners: PropTypes.array,
  selectedOrganization: PropTypes.object.isRequired,
  universities: PropTypes.object.isRequired,
  addSeason: PropTypes.func.isRequired,
  createDiscountHolder: PropTypes.func.isRequired,
  createDiscount: PropTypes.func.isRequired,
  lastAddedSeason: PropTypes.string.isRequired,
  lastAddedOwner: PropTypes.string.isRequired,
  fetchOwners: PropTypes.func.isRequired,
};

AddDiscountCard.defaultProps = {
  seasons: [],
  owners: [],
};

const mapStateToProps = state => ({
  seasons: getSeasons(state),
  owners: getOwners(state),
  selectedOrganization: getOrganization(state),
  universities: keyBy(state.auth.data.user.universities, '_id'),
  lastAddedSeason: state.discounts.seasons.lastAdded,
  lastAddedOwner: state.discounts.main.lastAdded,
  locale: state.appState.locale
});

const mapDispatchToProps = dispatch => ({
  addSeason: params => dispatch(addSeason(params)()),
  createDiscountHolder: params => dispatch(createDiscountHolder(params)()),
  createDiscount: params => dispatch(createDiscount(params)()),
});

export default compose(
  withStyles(styles, { name: 'AddDiscountCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(AddDiscountCard);



// WEBPACK FOOTER //
// ./src/modules/discounts/cards/AddDiscountCard/index.js